import styled from 'styled-components';
import { BaseMessage } from './BaseMessage';

export const InfoMessage = styled(BaseMessage)`
  background: #5476e9;
  color: #fff;
`;
